"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var AuthenticationService_1 = require("../Services/AuthenticationService");
var EventHandlerService_1 = require("../Services/EventHandlerService");
var Types_1 = require("../Types");
function saysWho() {
    var userAgent = navigator.userAgent;
    var tem;
    var userAgentMatch = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(userAgentMatch[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
        return { name: "IE", version: (tem[1] || "") };
        //return `IE ${tem[1] || ""}`;
    }
    if (userAgentMatch[1] === "Chrome") {
        tem = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
        //if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
        if (tem !== null)
            return { name: tem[1].replace("OPR", "Opera"), version: tem[2] };
    }
    userAgentMatch = userAgentMatch[2] ? [userAgentMatch[1], userAgentMatch[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = userAgent.match(/version\/(\d+)/i)) !== null)
        userAgentMatch.splice(1, 1, tem[1]);
    //return userAgentMatch.join(" ");
    var name = userAgentMatch[0], version = userAgentMatch[1];
    return { name: name, version: version };
}
exports.saysWho = saysWho;
function getQuery(params) {
    return Object.keys(params)
        .map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]); })
        .join('&');
}
exports.getQuery = getQuery;
function getJson1(url, options) {
    var headers = new Headers();
    headers.append("pragma", "no-cache");
    headers.append("cache-control", "no-cache");
    headers.append("accept", "application/json, application/xml, text/plain, text/html, *.*");
    headers.append("content-type", "application/json;");
    headers.append("Access-Control-Allow-Origin", "*");
    var defaultOptions = {
        credentials: "include",
        method: "GET",
        headers: headers,
        mode: "cors",
        redirect: "follow",
        body: null
    };
    options = Object.assign(defaultOptions, options);
    return new Promise(function (resolve, reject) {
        fetch(url, options).then(function (resp) {
            resp.json().then(function (data) {
                resp.ok ? resolve(data) : reject(data);
            }).catch(function (e) {
                reject(e);
            });
        }).catch(function (er) {
            reject(er);
        });
    });
}
exports.getJson1 = getJson1;
function getJson2(url, options) {
    var headers = new Headers();
    headers.append("pragma", "no-cache");
    headers.append("cache-control", "no-cache");
    headers.append("accept", "application/json, application/xml, text/plain, text/html, *.*");
    headers.append("content-type", "application/json;");
    headers.append("Access-Control-Allow-Origin", "*");
    var defaultOptions = {
        credentials: "include",
        method: "GET",
        headers: headers,
        mode: "cors",
        redirect: "follow",
        body: null
    };
    options = Object.assign(defaultOptions, options);
    return fetch(url, options)
        .then(function (response) {
        return response.json();
    })
        .catch(function (reason) { return console.error("Error loading " + url + ". With reason: " + reason); });
}
exports.getJson2 = getJson2;
var defaultHeaders = new Headers({
    "pragma": "no-cache",
    "cache-control": "no-cache",
    "accept": "application/json, application/xml, text/plain, text/html, *.*",
    "content-type": "application/json;",
    "Access-Control-Allow-Origin": "*"
});
var defaultGetOptions = {
    credentials: "include",
    method: "GET",
    headers: defaultHeaders,
    mode: "cors",
    redirect: "follow",
    body: null
};
exports.defaultPostOptions = {
    credentials: "include",
    method: "POST",
    headers: defaultHeaders,
    mode: "cors",
    redirect: "follow",
    body: null
};
exports.defaultDeleteOptions = {
    credentials: "include",
    method: "DELETE",
    headers: defaultHeaders,
    mode: "cors",
    redirect: "follow",
    body: null
};
var UserRequestHeaders = /** @class */ (function () {
    function UserRequestHeaders(user) {
        this.Organisation = user.Organisation;
        this.Location = user.Location;
        this.UserId = user.id;
    }
    UserRequestHeaders.prototype.AppendHeaders = function (options) {
        var headers = new Headers(options.headers);
        headers.append(UserRequestHeaders.OrganisationKey, encodeURI(this.Organisation));
        headers.append(UserRequestHeaders.LocationKey, encodeURI(this.Location));
        headers.append(UserRequestHeaders.UserIdKey, this.UserId);
        options.headers = headers;
    };
    UserRequestHeaders.OrganisationKey = "verilite-organisation";
    UserRequestHeaders.LocationKey = "verilite-location";
    UserRequestHeaders.UserIdKey = "verilite-userid";
    return UserRequestHeaders;
}());
exports.UserRequestHeaders = UserRequestHeaders;
var TransactionIdRequestHeader = /** @class */ (function () {
    function TransactionIdRequestHeader(id) {
        this.TransactionId = id;
    }
    TransactionIdRequestHeader.TransactionIdKey = "Transaction-Id";
    return TransactionIdRequestHeader;
}());
exports.TransactionIdRequestHeader = TransactionIdRequestHeader;
function postJson(url, body, options, useAuthentication, userRequestHeaders, manuallyHandleError, transactionIdRequestHeader) {
    if (options === void 0) { options = exports.defaultPostOptions; }
    if (useAuthentication === void 0) { useAuthentication = true; }
    if (userRequestHeaders === void 0) { userRequestHeaders = undefined; }
    if (manuallyHandleError === void 0) { manuallyHandleError = false; }
    if (transactionIdRequestHeader === void 0) { transactionIdRequestHeader = undefined; }
    return __awaiter(this, void 0, void 0, function () {
        var u, headers;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    options = Object.assign(__assign({}, exports.defaultPostOptions), options);
                    options = __assign(__assign({}, options), { body: body });
                    u = new UserRequestHeaders({});
                    if (!useAuthentication) return [3 /*break*/, 2];
                    return [4 /*yield*/, AuthenticationService_1.Auth.getAccessToken().then(function (token) {
                            var headers = new Headers(options.headers);
                            headers.append("Authorization", "Bearer " + token);
                            options.headers = headers;
                        }).catch(function (error) {
                            console.error("Error adding auth header: " + error);
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (userRequestHeaders != undefined) {
                        userRequestHeaders.AppendHeaders(options);
                    }
                    if (transactionIdRequestHeader != undefined) {
                        headers = new Headers(options.headers);
                        headers.append(TransactionIdRequestHeader.TransactionIdKey, transactionIdRequestHeader.TransactionId);
                        options.headers = headers;
                    }
                    return [2 /*return*/, fetch(url, options)
                            .then(function (response) {
                            //console.log(response)
                            if (!response.ok) {
                                //console.log(response.status)
                                if (response.status === 401 || response.status === 403) {
                                    throw window.resources.SorryWeWereUnableToMakeYourRequest;
                                }
                                else if (response.status == 400) {
                                    return new Promise(function (resolve, reject) {
                                        response.json().then(function (json) {
                                            //console.log(json)
                                            reject(json);
                                        }).catch(function (e) {
                                            console.error(e);
                                            throw e;
                                        });
                                    });
                                }
                                else {
                                    throw window.resources.SomethingWentWrongContact;
                                }
                            }
                            else {
                                //console.log("postJsonResponse")
                                //console.log(response.body)
                                return response.json().then(function (json) {
                                    //console.log("then")
                                    return new Promise(function (resolve) { return resolve(json); });
                                }).catch(function (e) {
                                    //console.log("catch")
                                    return new Promise(function (resolve) { return resolve(true); });
                                });
                            }
                        })
                            .catch(function (reason) {
                            //console.log(`hit catch: ${reason}`)
                            console.error(reason);
                            if (manuallyHandleError) {
                                return new Promise(function (resolve, reject) { return reject(reason); });
                            }
                            else {
                                EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(new Types_1.VeriLiteErrorEvent(reason));
                                return new Promise(function (resolve) { return resolve(""); });
                            }
                        })];
            }
        });
    });
}
exports.postJson = postJson;
function getJson(url, options, useAuthentication, userRequestHeaders) {
    if (options === void 0) { options = defaultGetOptions; }
    if (useAuthentication === void 0) { useAuthentication = true; }
    if (userRequestHeaders === void 0) { userRequestHeaders = undefined; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    options = Object.assign(__assign({}, defaultGetOptions), options);
                    if (!useAuthentication) return [3 /*break*/, 2];
                    return [4 /*yield*/, AuthenticationService_1.Auth.getAccessToken().then(function (token) {
                            var headers = new Headers(options.headers);
                            headers.append("Authorization", "Bearer " + token);
                            options.headers = headers;
                        }).catch(function (error) {
                            console.error("Error adding auth header: " + error);
                        })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (userRequestHeaders != undefined) {
                        userRequestHeaders.AppendHeaders(options);
                    }
                    return [2 /*return*/, fetch(url, options)
                            .then(function (response) {
                            if (!response.ok) {
                                if (response.status === 401 || response.status === 403) {
                                    throw window.resources.SorryWeWereUnableToMakeYourRequest;
                                }
                                else {
                                    throw window.resources.SomethingWentWrongContact;
                                }
                            }
                            else {
                                if (response.status !== 204) {
                                    return response.json();
                                }
                                else {
                                    return null;
                                }
                            }
                        })
                            .catch(function (reason) {
                            var _a;
                            var actions = Types_1.VeriLiteErrorEvent.DefaultActions(window.resources);
                            actions[0].callback = function (currentEvent, closeModalCallback) {
                                //todo error reports
                                console.error("Error calling " + url + " with reason: " + reason);
                                closeModalCallback();
                            };
                            EventHandlerService_1.EventHandlerProvider.GetInstance().AddEvent(new Types_1.VeriLiteErrorEvent(((_a = reason) === null || _a === void 0 ? void 0 : _a.message) || reason, undefined));
                            return new Promise(function (resolve) { return resolve(JSON.stringify("")); });
                        })];
            }
        });
    });
}
exports.getJson = getJson;
function copyText(textToCopy) {
    var textArea = document.createElement("textarea");
    textArea.value = textToCopy;
    textArea.style.position = "absolute";
    textArea.style.height = "0";
    textArea.style.width = "0";
    textArea.style.opacity = "0";
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
}
exports.copyText = copyText;
function isNullOrWhiteSpace(str) {
    return str == undefined || str === null || str.length < 1 || str.match(/^ *$/) !== null;
}
exports.isNullOrWhiteSpace = isNullOrWhiteSpace;
function convertExpiryDate(stringDate) {
    if (isNullOrWhiteSpace(stringDate)) {
        return "";
    }
    var day = +stringDate.substring(4, 6);
    var month = +stringDate.substring(2, 4) - (day > 0 ? 1 : 0);
    var year = +("" + new Date().getFullYear().toString().substring(0, 2) + stringDate.substring(0, 2));
    var date = new Date(year, month, day);
    var offset = date.getTimezoneOffset();
    var d = new Date(date.getTime() - (offset * 60000));
    var IsoDate = d.toISOString();
    var result = IsoDate.substring(0, 10);
    return result;
}
exports.convertExpiryDate = convertExpiryDate;
function parseBoolean(input) {
    switch (input) {
        case true:
        case "true":
        case "True":
        case "TRUE":
        case 1:
        case "1":
        case "on":
        case "On":
        case "ON":
        case "yes":
        case "Yes":
        case "YES":
            return true;
        default:
            return false;
    }
}
exports.parseBoolean = parseBoolean;
function getValueFromInputRef(ref) {
    return ref.current ? ref.current.value.trim() : "";
}
exports.getValueFromInputRef = getValueFromInputRef;
function getNameFromInputRef(ref) {
    return ref.current ? ref.current.name : "";
}
exports.getNameFromInputRef = getNameFromInputRef;
function stringifyEvent(e) {
    var obj = {};
    for (var k in e) {
        obj[k] = e[k];
    }
    return JSON.stringify(obj, function (k, v) {
        if (v instanceof Node)
            return 'Node';
        if (v instanceof Window)
            return 'Window';
        return v;
    }, ' ');
}
exports.stringifyEvent = stringifyEvent;
function GetResources(callback) {
    setTimeout(function () {
        if (window.resources == undefined) {
            GetResources(callback);
        }
        else {
            callback(window.resources);
        }
    }, 100);
}
exports.GetResources = GetResources;
;
//# sourceMappingURL=Util.js.map